import { each, find, get, mapValues, update } from 'lodash-es';

const chainableFunctions = {
  find,
  get,
  each,
  update,
};

export const chain = <T>(input: T) => {
  let value: any = input;

  const wrapper = {
    ...mapValues(chainableFunctions, (func: any) => {
      return (...args: any[]) => {
        // Handle specific logic for each method if needed
        value = func(value, ...args);
        return wrapper; // Return the wrapper to allow chaining
      };
    }),
    value: () => value,
  };

  return wrapper;
};
